const typeOperateTransactionString = () => {
  let data = {};
  data[typeOperateTransaction.ADD] = "اضافه کردن";
  data[typeOperateTransaction.SUBTRACT] = "کسر کردن";
  return data;
};

const typeOperateTransaction = {
  ADD: 1,
  SUBTRACT: 2,
};

export default {
  typeOperateTransactionString,
  typeOperateTransaction,
};
